import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../../lib/animations";

const integrations = [
  { name: "Meta", color: "#1877F2" },
  { name: "HubSpot", color: "#FF7A59" },
  { name: "Stripe", color: "#635BFF" },
  { name: "Vapi.ai", color: "#10B981" },
  { name: "Twilio", color: "#F22F46" },
  { name: "Nano Banana™", color: "#FACC15", hasIcon: true },
];

export function IntegrationsBarSection() {
  return (
    <section className="relative z-10 px-6 md:px-12 lg:px-24 py-16 bg-white">
      <div className="max-w-4xl mx-auto">
        <motion.p
          initial={fadeIn.initial}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.05 }}
          className="text-center text-xs font-semibold tracking-[0.2em] uppercase text-gray-400 mb-10"
        >
          Trusted Integrations
        </motion.p>

        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6">
          {integrations.map((item, i) => (
            <motion.span
              key={item.name}
              initial={{ opacity: 0.99, y: 6 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.05 }}
              transition={{ delay: i * 0.05 }}
              className="text-base font-semibold text-gray-300 hover:text-gray-900 transition-colors duration-300 cursor-default flex items-center gap-1.5"
              style={{ "--brand": item.color }}
              onMouseEnter={(e) => { e.currentTarget.style.color = item.color; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = ""; }}
            >
              {item.hasIcon && (
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                  <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="12" cy="12" r="4" />
                </svg>
              )}
              {item.name}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
}
